import { makeMessage } from '../message/index';
import { psLog } from '../utils';
import { RequestItem } from '../request-item';
import { ReqReadyState } from './common';
export class NetworkProxyBase {
    socketStore;
    reqMap = Object.create(null);
    constructor(socketStore) {
        this.socketStore = socketStore;
    }
    getRequestMap() {
        return this.reqMap;
    }
    getRequest(id) {
        const req = this.reqMap[id];
        return req;
    }
    removeRequest(id) {
        delete this.reqMap[id];
    }
    createRequest(id) {
        if (!id) {
            psLog.warn('The "id" is required when init request object');
            return false;
        }
        if (this.reqMap[id]) {
            psLog.warn('The request object has been in store, disallow duplicate create');
            return false;
        }
        this.reqMap[id] = new RequestItem(id);
        return true;
    }
    setRequest(id, req) {
        if (!id || !req)
            return false;
        this.reqMap[id] = req;
        return true;
    }
    static dataProcessor;
    sendRequestItem(id, req) {
        const processedByUser = NetworkProxyBase.dataProcessor?.(req);
        if (processedByUser === false)
            return;
        try {
            if (!this.reqMap[id]) {
                this.reqMap[id] = req;
            }
            const message = makeMessage('network', {
                ...req,
            }, false);
            this.socketStore.dispatchEvent('public-data', message);
            this.socketStore.broadcastMessage(message, req.readyState !== ReqReadyState.DONE);
            this.deferDeleteRequest(id);
        }
        catch (e) {
            psLog.error(e instanceof Error ? e.message : String(e));
        }
    }
    deferDeleteRequest(id) {
        const req = this.getRequest(id);
        if (req && req.readyState === ReqReadyState.DONE) {
            setTimeout(() => {
                delete this.reqMap[id];
            }, 3000);
        }
    }
}
